<template>
  <div>
    <v-layout wrap class="py-3">
      <v-flex xs6>
        <multiselect
          v-model="filterBeacon"
          class="mb-2"
          :options="beaconBranchOptions"
          :show-no-results="true"
          :placeholder="$t('Beacon')"
          label="name"
          track-by="beacon_id"
          @input="handleReset"
        >
        </multiselect>
      </v-flex>
      <v-flex xs6 class="text-sm-right text-xs-right">
        <v-btn dark depressed color="primary" @click="showAdvancedSearch = !showAdvancedSearch">
          <v-icon>search</v-icon>
          &nbsp;
          {{ $t('advanced search') }}&nbsp;
          <em v-if="!showAdvancedSearch" class="fas fa-angle-down" />
          <em v-else class="fas fa-angle-up" />
        </v-btn>
        <v-btn outline color="primary" @click="handleExportXlsx">
          <em class="fas fa-file-export" />&nbsp;{{ $t('export') }}
        </v-btn>
      </v-flex>
    </v-layout>

    <div
      v-if="showAdvancedSearch"
      class="mb-4 py-2"
      style="border: 1px solid #eee; border-radius: 10px; position: relative"
    >
      <v-layout wrap class="form-control">
        <v-flex xs6 px-2>
          <div class="caption">{{ $t('Name') }}</div>
          <input v-model="filter.line_name" type="text" :placeholder="$t('Name')" />
        </v-flex>
        <v-flex xs6 px-2>
          <div class="caption">{{ $t('group_audience') }}</div>
          <multiselect
            v-model="filter.group_audience"
            class="mb-2"
            :options="groupAudienceOptions"
            :show-no-results="true"
            :placeholder="$t('group_audience')"
            label="audience_name"
            track-by="id"
          >
          </multiselect>
        </v-flex>
        <v-flex xs12 class="text-xs-right">
          <v-btn outline color="grey" @click="handleClearSearch">{{ $t('Clear Search') }}</v-btn>
          <v-btn depressed color="primary" @click="handleSearch">
            <em class="fas fa-search mr-1" />
            {{ $t('Search') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </div>

    <div class="mt-3">
      <v-data-table hide-actions :pagination.sync="pagination" :headers="headers" :items="items">
        <template #items="props">
          <td class="py-2">
            <v-avatar size="48">
              <v-img
                :lazy-src="props.item.profile_pic"
                :src="
                  props.item.profile_pic
                    ? props.item.profile_pic
                    : '/static/img/assets/livechat/profile.png'
                "
                aspect-ratio="1"
                class="grey lighten-2"
              >
                <template #placeholder>
                  <v-layout fill-height align-center justify-center ma-0>
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                  </v-layout>
                </template>
              </v-img>
            </v-avatar>
          </td>
          <td>{{ props.item.line_name || '-' }}</td>
          <td>{{ props.item.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}</td>
          <td v-if="isSpecificBeaconPage">{{ props.item.audience_group_name || '-' }}</td>
          <td>
            <template v-if="transformTags(props.item.tags).length > 0">
              <template v-for="(tag, i) in transformTags(props.item.tags)">
                <v-chip :key="`tag-${i + 1}`" :color="`primary`" outline small>{{ tag }}</v-chip>
              </template>
            </template>
            <template v-else>-</template>
          </td>
          <td>
            <v-btn color="primary" depressed small @click="handleShowDetail(props.item)">
              {{ $t('view') }}
            </v-btn>
          </td>
        </template>

        <template slot="no-data">
          <div class="text-xs-center">{{ $t('No data') }}</div>
        </template>
      </v-data-table>
      <div class="mt-3 text-xs-right">
        <v-pagination
          v-model="pageNumber"
          :total-visible="6"
          :length="pageLength"
          @input="handleNextPage"
        ></v-pagination>
      </div>
    </div>

    <v-dialog v-model="showCustomerDetailDialog" width="950px" persistent>
      <CustomerDetailDialog
        v-if="selectedCustomer"
        v-model="selectedCustomer"
        :initial-filters="customerDetailInitialFilters"
        @close="handleCloseCustomerDetailDialog"
      />
    </v-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import * as XLSX from 'xlsx'
import beaconApi from '@/api/beacon'
import { handleResponse, handleApiError } from '@/api/util'
import CustomerDetailDialog from './CustomerDetailDialog.vue'
import bbqApi from '@/api/bbq'

export default {
  components: {
    Multiselect,
    CustomerDetailDialog
  },
  props: ['selectedDate'],

  data: function () {
    return {
      filterBeacon: null,
      items: [],
      headers: [
        { text: '', value: '', sortable: false },
        { text: this.$t('Name'), value: 'line_name', sortable: false },
        { text: `${this.$t('Date')} & ${this.$t('Time')}`, value: 'timestamp', sortable: false },

        { text: this.$t('group_audience'), value: 'group_audience', sortable: false },

        { text: this.$t('Tag'), value: 'tags', sortable: false },
        { text: '', value: '', sortable: false }
      ],
      limit: 10,
      offset: 0,
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      pagetmp: 1,
      pageNumber: 1,
      isExport: false,
      selectedCustomer: null,
      showCustomerDetailDialog: false,
      showAdvancedSearch: false,
      filter: {
        line_name: '',
        group_audience: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    pageLength() {
      if (this.total) {
        let total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    },
    beaconBranchOptions() {
      let options = []
      const tempData = this.$store.state.beaconMasterData.beaconBranch

      if (tempData) {
        options = tempData.map((el) => {
          return { beacon_id: el.beacon_id, name: el.name }
        })
      }
      return options
    },
    groupAudienceOptions() {
      let options = []
      const tempData = this.$store.state.beaconMasterData.groupAudience

      if (tempData) {
        options = tempData.map((item) => {
          return { id: item.id, audience_name: item.audience_name }
        })
      }

      return options
    },
    isSpecificBeaconPage() {
      return this.$store.state.beaconPageIdList.includes(this.selectedBot.pageid)
    },
    customerDetailInitialFilters() {
      return {
        ...(this.filterBeacon && {
          beaconId: this.filterBeacon.beacon_id
        }),
        ...(this.selectedDate && {
          dateFrom: dayjs(this.selectedDate.start).format('YYYY-MM-DD'),
          dateTo: dayjs(this.selectedDate.end).format('YYYY-MM-DD')
        })
      }
    }
  },
  watch: {
    selectedDate: function () {
      this.currentSelectedDate = this.selectedDate
      this.handleFetchData()
    }
  },
  mounted() {
    if (!this.isSpecificBeaconPage) {
      const tempHeaders = [...this.headers]
      this.headers = tempHeaders.filter((item) => item.value !== 'group_audience')
    }

    if (this.selectedDate) {
      this.currentSelectedDate = this.selectedDate
      this.handleFetchData()
    }

    if (this.$store.state.beaconMasterData.groupAudience.length === 0) {
      this.getAudienceList()
    }
  },
  methods: {
    async handleFetchData() {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await vm.getAnalyticsCustomer()
        vm.$store.commit('CLEAR_LOADING')

        if (response && response.status === 200) {
          const tempData = response.data.data
          vm.items = tempData
          vm.total = response.data.total
        }
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        handleApiError(error)
      }
    },
    async getAnalyticsCustomer() {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const limit = vm.isExport ? vm.total : vm.limit
        const config = {
          pageid: vm.selectedBot.pageid,
          data: {
            limit: limit,
            offset: vm.offset,
            dateFrom: this.selectedDate ? dayjs(this.selectedDate.start).format('YYYY-MM-DD') : '',
            dateTo: this.selectedDate ? dayjs(this.selectedDate.end).format('YYYY-MM-DD') : ''
          }
        }

        if (vm.filterBeacon) {
          Object.assign(config.data, { beaconId: vm.filterBeacon.beacon_id })
        }

        if (vm.filter.line_name) {
          Object.assign(config.data, { line_name: vm.filter.line_name })
        }
        if (vm.filter.group_audience) {
          Object.assign(config.data, { audience_group_id: vm.filter.group_audience.id })
        }

        const response = await beaconApi.getAnalyticsCustomer({ config: config })
        vm.$store.commit('CLEAR_LOADING')
        handleResponse(response)

        if (response && response.status === 200) {
          return response
        } else {
          return null
        }
      } catch (error) {
        handleApiError(error)
        vm.$store.commit('CLEAR_LOADING')
        return null
      }
    },
    handleNextPage(val) {
      const vm = this
      if (vm.pagetmp !== val) {
        vm.pagetmp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit
        vm.handleFetchData()
      }
    },
    async handleExportXlsx() {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        vm.isExport = true
        const response = await vm.getAnalyticsCustomer()
        const data = response.data.data
        vm.isExport = false

        if (data == null) return
        const requests = data.map((el) => {
          return {
            user_id: el.user_id,
            line_name: el.line_name,
            timestamp: dayjs(el.timestamp).format('DD/MM/YYYY HH:mm'),
            audience_group_name: el.audience_group_name,
            tags: el.tags
          }
        })

        const heading = [['User ID', 'Social Name', 'Date & Time', 'Group Audience', 'Tag(s)']]

        const wb = XLSX.utils.book_new()
        const ws = XLSX.utils.json_to_sheet([])
        XLSX.utils.sheet_add_aoa(ws, heading)
        XLSX.utils.sheet_add_json(ws, requests, { origin: 'A2', skipHeader: true })
        XLSX.utils.book_append_sheet(wb, ws)
        XLSX.writeFile(wb, `beacon-customer.xlsx`)
        vm.$store.commit('CLEAR_LOADING')
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        console.error(error)
      }
    },
    transformTags(value) {
      return value ? value.split(',') : []
    },
    handleShowDetail(item) {
      this.selectedCustomer = item
      this.showCustomerDetailDialog = true
    },
    handleCloseCustomerDetailDialog() {
      this.selectedCustomer = null
      this.showCustomerDetailDialog = false
    },
    handleSearch() {
      this.handleReset()
    },
    handleClearSearch() {
      this.filter = {
        line_name: '',
        group_audience: ''
      }
      this.showAdvancedSearch = false
      this.handleReset()
    },
    handleReset() {
      this.pageNumber = 1
      this.offset = 0
      this.handleFetchData()
    },
    async getAudienceList() {
      const vm = this
      try {
        const data = {
          page_id: vm.selectedBot.pageid,
          limit: 100,
          offset: 0
        }

        const response = await bbqApi.getAudienceList({
          config: data
        })

        handleResponse(response)
        if (response && response.status === 200) {
          const tempData = response.data.data || []
          vm.$store.state.beaconMasterData.groupAudience = tempData
        }
      } catch (error) {
        handleApiError(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/Beacon/Analytics/Customer.vue